// @flow
import React from "react"
import { omit } from "ramda"
import { compose, withHandlers, type HOC } from "recompose"
import withConnect from "hoc/withConnect"
import { filter } from "data/search/actions"
import type { SearchParams } from "data/search/types"
import type { Location, ProductGroup } from "data/app/types"
import { chooseGeolocation, chooseProductGroups } from "data/app/actions"
import { openModal } from "data/modals/actions"
import FilterInput from "searchFilters/Shared/FilterInput"
import SetMoreFilters from "modals/SetActivityFilters"
import AllActivityFilters from "./AllActivityFilters"

const MainFilter = ({
  geolocation,
  productGroups,
  filter,
  chooseGeolocation,
  chooseProductGroups,
  params,
  handleChangeProductTypeFilters,
  noPassport = false,
}) => (
  <React.Fragment>
    <AllActivityFilters
      geolocation={geolocation}
      productGroups={productGroups}
      chooseGeolocation={chooseGeolocation}
      chooseProductGroups={chooseProductGroups}
      filter={filter}
      params={params}
      noPassport={noPassport}
    />
    <FilterInput
      onClick={handleChangeProductTypeFilters}
      placeholder="Filters"
      value={omit(["affiliate"], params)}
      formatter={() => "Filters"}
    />
  </React.Fragment>
)

const mapDispatchToProps = {
  openModal,
}

type Outter = {|
  geolocation: ?Location[],
  productGroups: ?ProductGroup[],
  chooseGeolocation?: typeof chooseGeolocation,
  chooseProductGroups: typeof chooseProductGroups,
  params: SearchParams,
  filter: typeof filter,
  noPassport: boolean,
|}

const enhancer: HOC<*, Outter> = compose(
  withConnect(() => ({}), mapDispatchToProps),
  withHandlers({
    handleChangeProductTypeFilters: props => () =>
      props.openModal(SetMoreFilters, {}),
  }),
)

export default enhancer(MainFilter)



// WEBPACK FOOTER //
// ./src/pages/_Page/MainFilter/MobileFilters/index.js